module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesNatural@2x.3187137.jpg";